import { fireEvent } from 'utils/generic/event-bus';
import { EQuickBetManagerDispatchActions } from 'newelements/_Betslip/types/quick-bet';

export const toggleQuickBet = (payload?: boolean) => {
  fireEvent({
    key: EQuickBetManagerDispatchActions.TOGGLE_QUICK_BET,
    payload
  });
};
